import { IOrderBy } from '@src/models/api';
import { createEvent } from 'effector';
import { TStateStoreReducer } from '../../models';

type TPayload = {
  columnId: string;
};
type TReducer = TStateStoreReducer<TPayload>;

export const changeOrderingEvent = createEvent<TPayload>();
export const changeOrderingReducer: TReducer = (state, { columnId }) => {
  const newOrdering: IOrderBy = state.ordering
    ? {
        field: columnId,
        sortOrder: state.ordering[0]?.sortOrder === 'ASC' ? 'DESC' : 'ASC',
      }
    : {
        field: columnId,
        sortOrder: 'DESC',
      };

  return {
    ...state,
    paging: {
      offset: 0,
      limit: state.paging.limit,
    },
    ordering: [newOrdering],
  };
};
